import * as TYPES from './types';
export default {
    [TYPES.SET_TESTIMONIALS](state, payload) {
        state.testimonials = payload;
    },
    [TYPES.SET_AGENT](state, payload) {
        state.agent = payload;
    },
    [TYPES.SET_AGENT_ID](state, payload) {
        state.agentid = payload;
    }
};
